import { CachedSamplingConfig } from './cached-sampling-config';

export const cache = new CachedSamplingConfig();
